// extracted by mini-css-extract-plugin
export default {"menu":"Page_menu__faCGG","navbar":"Page_navbar__z0kgg","menuDropdownButton":"Page_menuDropdownButton__7zS6k"};